<template>
  <div>
    <b-container style="text-align: justify">
      <b-row class="mt-4 ml-2">
        <b-col cols="8">
          <b-jumbotron header-level="4" bg-variant="light">
            <template slot="header">
              {{mydb}}
            </template>
            <template slot="lead">
              RBPTD is a database for identifying cancer-related RBPs in humans and systematically investigating their
              functions and abnormalities by integrating different types of data, including gene expression profiles,
              prognosis data, and DNA copy number variation (CNV), among 28 cancers.
            </template>
            <hr class="my-4">
            <p>
              The workflow of RBPTD was showed as following:
            </p>
            <b-img src="static/TCGA.png" fluid alt="Responsive image"/>
            <h5>The information of RNA Binding Protein you could get are :</h5>
            <b-media>
              <h5>Differential Expression:</h5>
              <p>
                Significantly differentially expressed RBPs were identified by comparing their expression levels in
                cancer tissues with those in adjacent normal tissues using the DESeq2 (ver. 3.7) with the default
                settings. The raw P-values were then adjusted to the false discovery rate (FDR) using the
                Benjamini-Hochberg procedure. Then we found 454 significantly differentially expressed RBPs across 16 cancer types.
              </p>
              <p class="text-muted">NOTE: There are 3 types of tumor we cannot call differential expression analysis due
                to lack of the expression profiling data files of Normal and 9 don't have any significant differential
                expression gene. </p>
              <div id="deChart" style="height: 200px;"></div>
              <h5>Copy Number Variations:</h5>
              <p>The data were analysed using the genomic identification of significant targets in cancer
                (GISTIC) (ver. 2.0) with the human hg38 reference genome. According to the G-score calculated by
                GISTIC, significantly amplified or deleted regions were identified for each patient. And there were 2,307 CNVs in 975 RBPs</p>
              <div id="cnvChart" style="height: 200px;"></div>
              <h5>Survival Analysis:</h5>
              <p>We performed survival analysis for every RBPs using R package survival and we found a total of 1,970
                RBPs with significant prognostic value.</p>
              <div id="surChart" style="height: 200px;"></div>
            </b-media>
          </b-jumbotron>
        </b-col>
        <b-col cols="4">
          Database Version: 0.1.0 (2018.9)<br>
          <div class="w-100">
            <div id="staticsChart2" style="height: 600px;"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import 'zrender/lib/svg/svg'

export default {
  components: {},
  name: 'Home',
  data: function () {
    return {
      initOpts: {
        renderer: 'svg'
      },
      feature: [{de: 18, sur: 28, cnv: 28}],
      options2: {
        title: {
          text: 'Number Of Significant Genes:',
          subtext: 'threshold: 0.05'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ['DE', 'DE&CNV', 'DE&SUR', 'DE&CNV&SUR'],
          top: '8%'
        },
        grid: {
          left: '0%',
          right: '8%',
          bottom: '0%',
          top: '17%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: ['Adrenal Gland', 'Bile Duct', 'Bladder', 'Blood', 'Bone Marrow', 'Brain', 'Breast', 'Cervix', 'Colorectal', 'Esophagus', 'Eye', 'Head and Neck', 'Kidney', 'Liver', 'Lung', 'Lymph Nodes', 'Nervous System', 'Ovary', 'Pancreas', 'Pleura', 'Prostate', 'Skin', 'Soft Tissue', 'Stomach', 'Testis', 'Thymus', 'Thyroid', 'Uterus']
        },
        series: [
          {
            name: 'DE',
            type: 'bar',
            stack: '总量',
            data: [102, 275, 348, 201, 1, 0, 0, 115, 271, 204, 161, 0, 159, 120, 167, 122, 0, 0, 0, 11, 0, 117, 0, 0, 174, 0, 0, 79]
          },
          {
            name: 'DE&CNV',
            type: 'bar',
            stack: '总量',
            data: [4, 24, 2, 15, 0, 0, 0, 5, 28, 7, 6, 0, 11, 2, 6, 13, 0, 0, 0, 0, 0, 6, 0, 0, 8]
          },
          {
            name: 'DE&SUR',
            type: 'bar',
            stack: '总量',
            data: [43, 130, 32, 24, 0, 0, 0, 13, 66, 118, 11, 0, 24, 63, 5, 16, 0, 0, 0, 2, 0, 4, 0, 0, 3, 0, 0, 13]
          },
          {
            name: 'DE&CNV&SUR',
            type: 'bar',
            stack: '总量',
            data: [4, 11, 1, 1, 0, 0, 0, 0, 5, 4, 0, 0, 1, 1, 0, 4]
          }
        ]
      },
      deChart: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Adrenal Gland', 'Bile Duct', 'Bladder', 'Blood', 'Bone Marrow', 'Brain', 'Breast', 'Cervix', 'Colorectal', 'Esophagus', 'Eye', 'Head and Neck', 'Kidney', 'Liver', 'Lung', 'Lymph Nodes', 'Nervous System', 'Ovary', 'Pancreas', 'Pleura', 'Prostate', 'Skin', 'Soft Tissue', 'Stomach', 'Testis', 'Thymus', 'Thyroid', 'Uterus'],
            axisLabel: {
              interval: 0,
              rotate: 60
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'count',
            nameLocation: 'center',
            nameGap: 30
          }
        ],
        series:
            {
              type: 'bar',
              barWidth: '40%',
              data: [102, 275, 348, 201, 1, 0, 0, 115, 271, 204, 161, 0, 159, 120, 167, 122, 0, 0, 0, 11, 0, 117, 0, 0, 174, 0, 0, 79]
            }

      },
      cnvChart: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Adrenal Gland', 'Bile Duct', 'Bladder', 'Blood', 'Bone Marrow', 'Brain', 'Breast', 'Cervix', 'Colorectal', 'Esophagus', 'Eye', 'Head and Neck', 'Kidney', 'Liver', 'Lung', 'Lymph Nodes', 'Nervous System', 'Ovary', 'Pancreas', 'Pleura', 'Prostate', 'Skin', 'Soft Tissue', 'Stomach', 'Testis', 'Thymus', 'Thyroid', 'Uterus'],
            axisLabel: {
              interval: 0,
              rotate: 60
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'count',
            nameLocation: 'center',
            nameGap: 30
          }
        ],
        series:
            {
              type: 'bar',
              barWidth: '40%',
              data: [33, 171, 5, 87, 0, 22, 90, 173, 177, 84, 49, 223, 101, 124, 71, 114, 24, 0, 98, 85, 68, 86, 185, 117, 66, 39, 13]
            }

      },
      surChart: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Adrenal Gland', 'Bile Duct', 'Bladder', 'Blood', 'Bone Marrow', 'Brain', 'Breast', 'Cervix', 'Colorectal', 'Esophagus', 'Eye', 'Head and Neck', 'Kidney', 'Liver', 'Lung', 'Lymph Nodes', 'Nervous System', 'Ovary', 'Pancreas', 'Pleura', 'Prostate', 'Skin', 'Soft Tissue', 'Stomach', 'Testis', 'Thymus', 'Thyroid', 'Uterus'],
            axisLabel: {
              interval: 0,
              rotate: 60
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'count',
            nameLocation: 'center',
            nameGap: 30
          }
        ],
        series:
            {
              type: 'bar',
              barWidth: '40%',
              data: [901, 952, 187, 271, 136, 201, 620, 183, 450, 1080, 241, 360, 317, 1013, 89, 277, 161, 261, 125, 298, 103, 90, 948, 79, 88, 231, 64, 354]
            }

      }
    }
  },
  mounted () {
    this.draw()
  },
  methods: {
    draw: function () {
      let charts = {}
      // let myChart =
      const renderer = this.renderer || 'canvas'
      console.log(renderer)
      charts['options2'] = this.echarts.init(document.getElementById('staticsChart2'), {renderer: 'svg'})
      charts['deChart'] = this.echarts.init(document.getElementById('deChart'), null, {renderer: 'svg'})
      charts['cnvChart'] = this.echarts.init(document.getElementById('cnvChart'), {renderer: 'svg'})
      charts['surChart'] = this.echarts.init(document.getElementById('surChart'), {renderer: 'svg'})
      // myChart.setOption(this.options2)
      for (let i in charts) {
        charts[i].setOption(this[i])
      }
    }
  }
}
</script>

<style scoped>
  p {
    text-indent: 2em
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue